module.exports = __webpack_public_path__ + "img/copy-icon.acefb090.png";